<app-shared-ranking-history
    [departmentType]="departmentType"
></app-shared-ranking-history>
